var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53299 1C6.55946 1 3.50926 2.72101 1.10801 6.16303C1.03946 6.26236 1.0019 6.37978 1.00007 6.50045C0.998237 6.62111 1.03221 6.73962 1.0977 6.84098C2.94271 9.72905 5.95209 11.9876 9.53299 11.9876C13.075 11.9876 16.1462 9.72218 17.9946 6.82763C18.0586 6.72825 18.0926 6.61256 18.0926 6.49438C18.0926 6.37619 18.0586 6.26051 17.9946 6.16113C16.142 3.29977 13.0483 1 9.53299 1Z",
    stroke: "black",
    strokeWidth: 1.22085,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54589 9.54612C11.2315 9.54612 12.598 8.17965 12.598 6.49401C12.598 4.80837 11.2315 3.44189 9.54589 3.44189C7.86025 3.44189 6.49377 4.80837 6.49377 6.49401C6.49377 8.17965 7.86025 9.54612 9.54589 9.54612Z",
    stroke: "black",
    strokeWidth: 1.22085,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.64f5acf342ff4bc8e8e5c477d2229adb.svg";
export { ForwardRef as ReactComponent };